import { Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { DEFAULT_INTERRUPTSOURCES, Idle } from '@ng-idle/core';
import { filter } from 'rxjs/operators';
import Swal from 'sweetalert2';
import { AuthService } from './services/auth.service';
import { CheckAppVersionService } from './services/check-app-version.service';
import { DeviceService } from './services/device.service';
import { GaTrackingService } from './services/ga-tracking.service';
import { ParametroService } from './services/parametro.service';

const APP_VERSION_STORAGE_KEY = 'app-version';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent {
  // constructor(
  //   private router: Router,
  //   private parametroService: ParametroService
  // ) {}

  constructor(
    private router: Router,
    private idle: Idle,
    private parametroService: ParametroService,
    private authService: AuthService,
    private gaTrackingService: GaTrackingService,
    private deviceService: DeviceService,
    private checkAppVersionService: CheckAppVersionService)
{}

  ngOnInit() {
    this.initAnalytics();
    this.markDeviceType();
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => this.checkAppVersion());


    if(this.authService.isLoggedIn()){
      this.idle.setIdle(1800); //1800 = 30min
      this.idle.setTimeout(2);
      this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);
      this.idle.onIdleEnd.subscribe(() => {
        console.log('Fin de inactividad detectado. Usuario activo.');
      });
  
      this.idle.onIdleStart.subscribe(() => {
        console.log("Inicio de Inactividad....");
      });
  
      this.idle.onTimeout.subscribe(() => {
        console.log('Tiempo de inactividad alcanzado. Mostrando la ventana modal.');
        Swal.fire({
          title: 'Sesión Terminada',
          text: 'Estuviste inactivo por algunos minutos... Por favor Recarga la página',
          imageUrl: 'assets/iconos/clock_alert.png',
          imageAlt: 'Imagen de advertencia',
          showCancelButton: false,
          backdrop: 'static',
          confirmButtonText: 'Recargar página',
          allowOutsideClick: false,
        }).then((result) => {
          // this.router.navigate(['/login']);
          location.reload();
        });      
        //this.authService.logout();

        // Swal.fire({
        //   title: 'Sesión Terminada',
        //   text: 'Estuviste inactivo por algunos minutos... Por favor vuelve a Iniciar Sesión',
        //   imageUrl: 'assets/iconos/clock_alert.png',
        //   imageAlt: 'Imagen de advertencia',
        //   showCancelButton: true, // Agregamos un segundo botón
        //   cancelButtonText: 'Recargar Página', // Texto del botón de recarga
        //   backdrop: 'static',
        //   confirmButtonText: 'Iniciar Sesión',
        //   allowOutsideClick: false,
        // }).then((result) => {
        //   if (result.isConfirmed) {
        //     this.router.navigate(['/login']); // Navega a la página de login
        //   } else if (result.dismiss === Swal.DismissReason.cancel) {
        //     location.reload(); // Recarga la página
        //   }
        // });
        
      });
      this.idle.watch();
    }
  }

  /**
   * Inicializa Google Analytics (GA4) y habilita el tracking de navegacion tipo SPA:
   * en cada NavigationEnd del router se envia un page_view usando la URL como titulo,
   * de modo que cada vista se pueda identificar en los reportes de GA4.
   */
  private initAnalytics(): void {
    this.gaTrackingService.initializeAnalytics().subscribe({
      error: (err) => console.warn('AppComponent: GA no pudo inicializarse.', err)
    });

    this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.gaTrackingService.trackPageView(event.urlAfterRedirects);
      });
  }

  /**
   * Marca el <body> con una clase segun el tipo de dispositivo detectado
   * (is-mobile / is-tablet / is-desktop) para que cualquier pagina pueda
   * adaptar su UI via CSS, y deja disponible el DeviceService para que
   * los componentes lo inyecten cuando necesiten logica condicional.
   */
  private markDeviceType(): void {
    const deviceType = this.deviceService.getDeviceType();
    document.body.classList.add(`is-${deviceType}`);
    if (this.deviceService.isTouchDevice()) {
      document.body.classList.add('is-touch');
    }
  }

  private checkAppVersion(): void {
    this.checkAppVersionService.getBuild().subscribe({
      next: (build) => {
        const storedVersion = localStorage.getItem(APP_VERSION_STORAGE_KEY);

        if (!storedVersion) {
          localStorage.setItem(APP_VERSION_STORAGE_KEY, build);
          return;
        }

        if (build !== storedVersion) {
          localStorage.setItem(APP_VERSION_STORAGE_KEY, build);
          Swal.fire({
            title: 'Nueva versión disponible',
            text: 'Se publicó una nueva versión de la aplicación. Actualice la página para continuar.',
            showCancelButton: false,
            backdrop: 'static',
            confirmButtonText: 'Actualizar página',
            allowOutsideClick: false,
            allowEscapeKey: false,
          }).then(() => {
            window.location.reload();
          });
        }
      },
      error: () => {
        // build.txt no disponible (ng serve local, error de red, etc.)
      }
    });
  }

}

